import {
  IconCaptain,
  IconFigure,
  IconInvictus,
  IconGolRecibed,
  IconCard,
  IconGol,
  IconWrongPenal,
  IconSavedPenal,
  IconGolPenal,
  IconSelfGol,
  IconVisitor,
  IconDontAdd,
  IconGoldendGol,
} from '../Icons';

/**
 * Referencias de ayudante de campo.
 * (íconos de conceptos de puntuación)
 */
export const ReferencesFieldAssistance = () => {
  return (
    <div className="hidden lg:block">
      <p className="h-9 mt-2 px-9 border-b-[1px] border-b-gdt-gray-5 flex items-center text-sm font-bold text-gdt-gray-2">
        Referencias
      </p>
      <div className="px-9 pt-4">
        <div className="flex justify-between">
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconCaptain />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Capitán
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconFigure />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Figura
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconInvictus />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Valla Invicta
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconGolRecibed />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Gol Recibido
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconGoldendGol />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Gol de oro
            </span>
          </div>
          <div className="flex items-center gap-2 justify-normal">
            <figure>
              <IconCard
                bgColor="bg-gdt-status-yellow-light"
                color="text-gdt-status-yellow"
              />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Amarilla
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-5">
              <IconCard
                bgColor="bg-gdt-status-red-light"
                color="text-gdt-status-red"
              />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">Roja</span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconGol />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">Gol</span>
          </div>
        </div>
        <div className="flex gap-5 mt-5">
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconWrongPenal />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Penal errado
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconSavedPenal />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Penal atajado
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconGolPenal />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Gol de penal
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconSelfGol />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Gol en contra
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconVisitor />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              Visitante
            </span>
          </div>
          <div className="flex items-center gap-2">
            <figure className="w-6">
              <IconDontAdd />
            </figure>
            <span className="text-xs font-semibold text-gdt-gray-3">
              No sumó puntos
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
